// src/components/dashboard/Donut.jsx

import React from 'react';
import { COLORS } from '../../constants';

export default function Donut({
  value,
  total,
  size = 100,
  thickness = 10,
  color,
  showPercent = true,
  label,
}) {
  const percentage = total > 0 ? (value / total) * 100 : 0;

  const radius = (size - thickness) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (percentage / 100) * circumference;

  const resolvedColor =
    color ??
    (percentage >= 80
      ? COLORS.success
      : percentage >= 50
        ? COLORS.warning
        : COLORS.danger);

  return (
    <div
      style={{
        display: 'inline-flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={COLORS.line}
          strokeWidth={thickness}
        />

        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={resolvedColor}
          strokeWidth={thickness}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />

        {showPercent && (
          <text
            x={size / 2}
            y={size / 2 + size * 0.06}
            textAnchor="middle"
            fill={resolvedColor}
            fontSize={size * 0.16}
            fontWeight="800"
          >
            {Math.round(percentage)}%
          </text>
        )}
      </svg>

      {label && (
        <span
          style={{
            fontSize: 12,
            color: COLORS.textSecondary,
            marginTop: 8,
            fontWeight: 600,
            textAlign: 'center',
          }}
        >
          {label}
        </span>
      )}
    </div>
  );
}